import {
  Component,
  OnInit, Output,
  EventEmitter,
  AfterViewInit,
  HostListener,
  ElementRef,
  ViewChild,
  Inject,
  OnDestroy,
  PLATFORM_ID,
  Input,
} from '@angular/core';
import {DatePipe, isPlatformBrowser} from '@angular/common';
import { NzInputDirective } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { fromEvent, Subscription, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import {TaskService} from '../../services/task.service';
import { ResizeEvent } from 'angular-resizable-element';
import {UtilsModule} from '../../utils/utils.module';
import { NgxPermissionsService } from 'ngx-permissions';
import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';
@Component({
  selector: 'task-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css'],
  providers: [TaskService, DatePipe]
})
export class TableComponent implements OnInit, AfterViewInit, OnDestroy {
  dataSubscription: Subscription = null;
  tplModal: NzModalRef;
  boardId = null; // 存放面板ID
  boardWidth: number; // 面板宽度
  boardData: any = {}; // 面板数据
  boardGroupData: Array<any> = []; // 面板组数据
  sortBoardGroupData = new Array<any>(); // 排序后的面板数据
  boardPulseData: Array<any> = []; // 面板列表数据
  boardColumnData: Array<any> = []; // 面板表头数据
  isAddBtnVisible = false; // 是否显示新增按钮 默认隐藏
  taskOrderEnableVisible = false;
  editNameId: string | null; // 编辑ID
  subscribeScoll: any; // 监控滚动条
  showColumnShadow = false; // 是否显示固定列阴影
  currentColumnId = ''; // 当前列ID
  addPulseNameValue = ''; // 添加行输入框绑定值
  clickCurrentColumnValue = null; // 是否点击当前列
  clickCurrentPulseValue = null; // 是否点击当前行
  progressSubmitState = false; // 进度分配提交按钮状态
  canColumnDrag = false; // 是否可拖动列宽
  pulseCheckedData: any = {}; // 行选中数据
  pulseCheckedId = []; // 选中行ID
  movePulsePopVisible = false;
  isDialogVisible = false; // 会话窗口开启状态
  conversationBaseData: any = {}; // 会话窗口基础数据
  isTaskOrderVisible = false; // 是否开启任务排序
  initGroupColor = [
    'rgb(3, 127, 76)',
    'rgb(0, 200, 117)',
    'rgb(156, 211, 38)',
    'rgb(202, 182, 65)',
    'rgb(255, 203, 0)',
    'rgb(120, 75, 209)',
    'rgb(0, 134, 192)',
    'rgb(87, 155, 252)',
    'rgb(102, 204, 255)',
    'rgb(187, 51, 84)',
    'rgb(226, 68, 92)',
    'rgb(255, 21, 138)',
    'rgb(255, 90, 196)',
    'rgb(255, 100, 46)',
    'rgb(253, 171, 61)',
    'rgb(127, 83, 71)',
    'rgb(100,127,120)',
    'rgb(196, 196, 196)',
    'rgb(128, 128, 128)',
    'rgb(51, 51, 51)'
  ]; // group默认组颜色
  dropdownInputValue = '';
  groupLabels = [];
  isDropdownOptionEdit = true;
  collapseGroups: Array<any> = []; // 存放折叠的组Id
  pulsesCounts: any = {}; // 存放组任务统计
  isConfirmLoading = false; // 批量修改弹窗提交按钮状态
  buttonConfigStatus = true; // 按钮配置项显示状态
  buttonConfigTitle = null; // 按钮配置-标题
  buttonConfigDisabled = true; // 按钮配置-是否可用
  buttonConfigUrl = null; // 按钮配置-url
  isExternalUrl = false; // 是否外部地址
  buttonConfigEditStatus = false; // 按钮配置-是否编辑状态
  buttonConfigEditeData: any = {}; // 按钮配置-存放当前编辑项数据
  clickButtonLoading: boolean; // 按钮配置 - 按钮loading
  permissionDefinition: any; // 存放面板权限配置
  currentUser: any; // 存放当前用户信息
  @ViewChild(NzInputDirective, { read: ElementRef }) inputElement: ElementRef;
  @ViewChild('addPulseInput') addPulseInput: ElementRef;
  @ViewChild('myInput') myInput: ElementRef;
  @ViewChild('modalTplContent', { static: true }) modalTplContent: any;
  @ViewChild('tplFooter', { static: true }) tplFooter: any;
  @ViewChild('pulseCard') pulseCard: any;
  confirmModal: NzModalRef; // 确认框
  boardClientWidth: number; // 面板首屏宽
  isMemberVisible = false; // 选择成员
  currentColumnData: any; // 存放当前列数据
  filterConditionCount = 0;
  filterData = {
    groups: [],
    groupLabels: [],
    selectedGroups: [],
    selectedLabels: [],
    columns: []
  };
  filterColumnExclude = ['progress', 'time-interval', 'relation-data', 'button', 'vote']; // 不支持筛选的列
  // 批量设置成员
  isBatchAddMemberVisible = false;
  batchAttachMemberVisible = false;
  isLoading = false;
  total: number;
  pageIndex = 1;
  pageSize = 999;
  searchKey;
  getBoardUserList: Observable<any>;
  loadMoreData = true;
  memberList: Array<any> = [];
  randomUserUrl: string;
  lastColumn;
  selectedMemberValue: Array<any> = [];
  selectedTaskValue: Array<any> = [];
  currendColumnValues: any;
  isBatchAddMemberLoading = false;
  groupAuthority: any = {
    edit: {
      status: false,
      members: []
    },
    view: {
      status: false,
      members: []
    }
  };
  boardList = [];
  progressCheckedId: string; // 进度列设置当前选择项
  // 任务系统参数
  taskSystemParameter: any;
  @Input('nfData') set ChangeData(data: any) {
    if (JSON.stringify(data) !== '{}') {
      this.boardData = data;
      this.handleBoardList(this.boardData);
    }
  }
  @Input() showFilter = true;
  @Output() nfUpdateTable: EventEmitter<any> = new EventEmitter<any>();
  @Input('taskSystemParameter') set ChangeParam(data: any) {
    if (data) {
      this.taskSystemParameter = data;
    }
  }
  constructor(
    private taskService: TaskService,
    private message: NzMessageService,
    private modal: NzModalService,
    private http: HttpClient,
    private utilsModule: UtilsModule,
    private datePipe: DatePipe,
    private permissionsService: NgxPermissionsService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  ngOnInit() {
    setTimeout(() => {
      if (document.getElementById('content-wrapper')) {
        this.boardClientWidth = document.getElementById('content-wrapper').offsetWidth;
      }
    }, 100);
    this.taskService.getUserBoardData().subscribe(res => {
      if (res) {
        this.boardList = res.boards || [];
      }
    });
  }
  ngAfterViewInit() {
    this.listenerScroll();
  }
  ngOnDestroy() {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }
  // 处理面板数据
  handleTaskOrder(data) {
    // this.boardGroupData.forEach(group => {
    //   data.boardData.pulses.forEach((pulse, i) => {
    //     const arr = [];
    //     if (group.id === pulse.groupId) {
    //       arr.push(pulse);
    //     }
    //     this.boardPulseData = this.boardPulseData.concat(arr);
    //   });
    // });
    // const obj = {};
    // this.boardPulseData = this.boardPulseData.reduce((cur, next) => {
    //   obj[next.id] ? '' : obj[next.id] = true && cur.push(next);
    //   return cur;
    // }, []);
    // this.boardPulseData.forEach((item, i) => {
    //   item.order = i + 1;
    // });
  }
  handleBoardList(data) {
    this.boardGroupData = data.boardData.groups ? data.boardData.groups : [];
    this.sortBoardGroupData = data.boardData.groups ? data.boardData.groups : [];
    this.boardColumnData = data.boardData.columns ? data.boardData.columns : [];
    this.boardGroupData.forEach(item => {
      if (item.taskOrderEnable === 'true') {
        this.taskOrderEnableVisible = true;
      }
    });
    this.boardPulseData = data.boardData.pulses ? data.boardData.pulses : [];
    // 处理分组任务顺序
    // this.handleTaskOrder(data);
    // 列排序
    this.boardGroupData.forEach(group => {
      const sortString = group.sort;
      if (sortString) {
        const sortMap = JSON.parse(sortString);
        this.boardColumnData.forEach(column => {
          if (sortMap.type === column.type) {
            column.sort = sortMap.sort;
            this.sortColumn(column, 'init', group);
          }
        });
      }
    });
    this.boardId = data.id;
    this.pulsesCounts = data.boardData.groupsPulsesCount;
    this.permissionDefinition = data.permissionDefinition;
    this.currentUser = data.boardData.currentUser;
    // load permissions
    this.permissionsService.loadPermissions(this.currentUser.permissions ? this.currentUser.permissions : []);
    // 计算面板宽度
    this.calcBoardWidth();
    // 进度组件赋值
    this.setProgressValue();
    // 处理组内任务统计
    this.handleGroupCount();
    // 计算筛选条件
    this.calcFilterData();
    // 处理分组标签
    this.handleGroupLabel();
  }

  handleGroupLabel() {
    this.groupLabels = [];
    if (this.boardGroupData && this.boardGroupData.length > 0) {
      const labels = [];
      this.boardGroupData.forEach(group => {
        const label = group.label;
        if (label) {
          const split = label.split(',');
          split.forEach(val => {
            this.groupLabels.push(val);
          });
        }
        this.groupLabels = Array.from(new Set(this.groupLabels));
      });
    }
    // 分组标签
    const newArr = [];
    this.groupLabels.forEach(item => {
      const obj = {
        name: item,
        id: this.genID(8)
      };
      newArr.push(obj);
    });
    this.filterData.groupLabels = newArr;
  }
  // 处理组内任务统计
  handleGroupCount() {
    this.boardGroupData.forEach((item, index) => {
      for (const key in this.pulsesCounts) {
        if (this.pulsesCounts.hasOwnProperty(key)) {
          if (item.id === key) {
            this.boardGroupData[index].count = this.pulsesCounts[key];
          }
        }
      }
    });
  }
  // 计算面板宽度
  calcBoardWidth() {
    this.boardWidth = 0;
    this.boardColumnData.forEach((item, index) => {
      let val = 0;
      if (item.width) {
        val = item.width;
      } else {
        val = 166;
      }
      this.boardWidth = this.boardWidth + val;
      if (document.getElementById('first-level-content')) {
        const cw = document.getElementById('first-level-content').clientWidth;
        this.canColumnDrag = cw < this.boardWidth;
      }
    });
  }
  @HostListener('window:click', ['$event'])
  handleClick(e: MouseEvent): void {
    if (this.editNameId && this.inputElement && this.inputElement.nativeElement !== e.target &&
      !this.hasClass(e.target, 'cdk-overlay-backdrop nz-overlay-transparent-backdrop')) {
      this.editNameId = null;
    }
    if (this.clickCurrentColumnValue && this.hasClass(e.target, 'cdk-overlay-backdrop nz-overlay-transparent-backdrop')) {
      this.clickCurrentColumnValue = null;
    }
    if (this.clickCurrentPulseValue && this.hasClass(e.target, 'cdk-overlay-backdrop nz-overlay-transparent-backdrop')) {
      this.clickCurrentPulseValue = null;
    }
  }
  // hasClass
  hasClass(elem, className) {
    const reg = new RegExp('(^|\\s+)' + className + '($|\\s+)');
    return reg.test(elem.className);
  }
  dropGroup(event: CdkDragDrop<string[]>) {
    const pos = [];
    const oldGroup = [...this.sortBoardGroupData];
    oldGroup.forEach(group => pos.push(group.position));
    moveItemInArray(this.boardGroupData, event.previousIndex, event.currentIndex);
    const params = [];
    this.boardGroupData.forEach((value, index) => {
      params.push({
        id: value.id,
        title: value.title,
        position: pos[index]
      });
    });
    this.taskService.changeGroupPos(params).subscribe(res => {
      this.sortBoardGroupData = [...params];
      if (!res) {
        this.message.error('保存分组位置异常！');
      }
    });
  }
  dropColumn(event: CdkDragDrop<string[]>) {
    const pos = [];
    this.boardColumnData.forEach(column => pos.push(column.position));
    moveItemInArray(this.boardColumnData, event.previousIndex + 1, event.currentIndex + 1);
    const params = [];
    for (let i = 0; i < this.boardColumnData.length; i++) {
      params.push({
        id: this.boardColumnData[i].id,
        title: this.boardColumnData[i].title,
        position: pos[i]
      });
    }
    this.taskService.changeColumnPos(params).subscribe(res => {
      if (!res) {
        this.message.error('保存列位置异常！');
      }
    });
  }
  // 添加分组
  addNewGroup(boardId) {
    const color = this.utilsModule.getRandomColor();
    const param = {};
    param['title'] = '新组';
    param['color'] = color;
    this.dataSubscription = this.taskService.doAddGroup(boardId, param).subscribe((res: any) => {
      if (res) {
        const groupObj = {
          'title': res.title,
          'color': res.color,
          'id': res.id,
          'boardId': res.boardId
        };
        this.boardGroupData = [
          groupObj,
          ...this.boardGroupData
        ];
        this.nfUpdateTable.emit(true);
      }
    });
  }
  // 添加组列
  addColumnFun(boardId, type) {
    const param = {
      type: type,
      title: type
    };
    this.dataSubscription = this.taskService.doAddColumn(boardId, param).subscribe((res: any) => {
      if (res) {
        const obj = JSON.parse(res.definition);
        this.nfUpdateTable.emit(true);
        this.setProgressValue();
        this.addFilterColumn(obj);
      }
    });
  }
  // 添加组行
  addPulse(boardId, groupId) {
    const o = {};
    this.boardColumnData.forEach((item, index) => {
      if (item.type === 'multiple-person') {
        o[item.id] = {'personsAndTeams' : []};
      } else if (item.type === 'status') {
        o[item.id] = {
          'index': 0
        };
      } else if (item.type === 'date') {
        o[item.id] = {};
      } else if (item.type === 'date-time') {
        o[item.id] = {};
      } else if (item.type === 'time-interval') {
        o[item.id] = {};
      } else if (item.type === 'name') {
        o[item.id] = this.addPulseNameValue;
      } else if (item.type === 'dropdown') {
        o[item.id] = {};
      } else if (item.type === 'file') {
        o[item.id] = {
          config: {
            watermark: true,
            watermarkContent: ''
          },
          files: []
        };
      } else if (item.type === 'link') {
        o[item.id] = {
          name: '',
          url: '',
          params: [],
          skipMode: '1'
        };
      } else {
        o[item.id] = '';
      }
    });
    o['name'] = this.addPulseNameValue;
    const param = {};
    param['boardId'] = boardId;
    param['groupId'] = groupId;
    param['name'] = this.addPulseNameValue;
    param['columnValues'] = {
      'name': this.addPulseNameValue
    };
    this.dataSubscription = this.taskService.doAddPulse(param).subscribe((res: any) => {
      if (res) {
        this.boardPulseData = [
          ...this.boardPulseData,
          {
            id: res.id,
            groupId: res.groupId,
            name: this.addPulseNameValue,
            columnValues: o,
            columnPermissions: res.columnPermissions,
            updatesCount: 0
          }
        ];
        this.boardGroupData.forEach(group => {
          if (group.id === groupId) {
            group.pulses = [
              ...group.pulses,
              {
                id: res.id,
                groupId: res.groupId,
                name: this.addPulseNameValue,
                columnValues: o,
                columnPermissions: res.columnPermissions,
                updatesCount: 0
              }
            ];
          }
        });
      }
      this.addPulseNameValue = '';
    });
  }
  // 获取添加行输入值
  getAddPulseName(value) {
    this.addPulseNameValue = value;
  }
  // 表头编辑状态切换
  changeHeaderEditable(groupId, columnId, event) {
    event.preventDefault();
    event.stopPropagation();
    this.editNameId = groupId + columnId;
  }
  // 获取组名修改后的值
  getGroupHeader(title, boardId, groupId, color) {
    const param = {
      title: title,
      color: color
    };
    this.editNameId = null;
    this.dataSubscription = this.taskService.doEditGroupTitle(boardId, groupId, param).subscribe((res: any) => {});
  }
  // 更换组颜色
  changeGroupColor(boardId, groupId, color) {
    const param = {
      color: color
    };
    this.boardGroupData.forEach((item, index) => {
      if (item.id === groupId) {
        item.color = color;
      }
    });
    this.dataSubscription = this.taskService.doEditGroupTitle(boardId, groupId, param).subscribe((res: any) => {});
  }
  // 获取表头修改后的值
  getColumnHeader(title, boardId, columnId) {
    const param = {
      title: title
    };
    this.editNameId = null;
    this.dataSubscription = this.taskService.doEditColumnHeader(boardId, columnId, param).subscribe((res: any) => {});
  }
  // 行编辑状态切换
  changePulseEditable(groupId, columnId, pulseId, event) {
    event.preventDefault();
    event.stopPropagation();
    this.editNameId = groupId + columnId + pulseId;
  }
  // 添加行输入框状态切换
  changeAddPulseEditable(groupId, columnId, event, inputTemp) {
    for (const item of this.boardGroupData) {
      if (item.id == groupId && !item.editEnable) {
        this.message.info('您没有该分组的编辑权限!');
        return;
      }
    }
    event.preventDefault();
    event.stopPropagation();
    this.editNameId = 'add' + groupId + columnId;
    // 自动获取输入框焦点
    setTimeout(() => {
      if (isPlatformBrowser(this.platformId)) {
        this[inputTemp].nativeElement.focus();
      }
    }, 100);
  }
  // 获取行NAME编辑值
  getColumnName(pulseId, value, columnId) {
    if (value) {
      const param = {};
      param['name'] = value;
      this.dataSubscription = this.taskService.doEditPulseName(pulseId, param).subscribe((res: any) => {
        this.editNameId = null;
        this.updateFilterData(columnId);
      });
    }
  }
  // 获取文本单元格编辑值
  getColumnText(pulse, column, value) {
    const param = {};
    param['pulseIds'] = [pulse.id];
    param['columnId'] = column.id;
    param['columnValue'] = value;
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
      this.editNameId = null;
      this.updateFilterData(column.id);
    });
  }
  // 获取关联数据组件的值
  getRelationData(pulseId, columnId, value) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = columnId;
    param['columnValue'] = value;
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe(res => {});
  }
  getVoteData(pulse, columnId, value) {
    const param = {};
    param['pulseIds'] = [pulse.id];
    param['columnId'] = columnId;
    param['columnValue'] = {
      voters: value
    };
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {});
  }
  // 获取复选组件的值
  getCheck(pulse, columnId) {
    const columnValue = pulse.columnValues[columnId] != 'true';
    const param = {};
    param['pulseIds'] = [pulse.id];
    param['columnId'] = columnId;
    param['columnValue'] = columnValue;
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
      pulse.columnValues[columnId] = columnValue + '';
      this.updateFilterData(columnId);
    });
  }
  // 获取行日期组件编辑的值
  getColumnDate(pulseId, columnId, event) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = columnId;
    param['columnValue'] = {
      'date': event ? this.datePipe.transform(event, 'yyyy-MM-dd') : ''
    };
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
      this.updateFilterData(columnId);
    });
  }
  getTimeInterval(pulseId, columnId, event) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = columnId;
    if (event && event.length == 2) {
      const format = 'yyyy-MM-dd HH:mm';
      param['columnValue'] = {
        'date': [this.datePipe.transform(event[0], format), this.datePipe.transform(event[1], format)]
      };
    } else {
      param['columnValue'] = {
        'date': []
      };
    }
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {});
  }
  getColumnDateTime(pulseId, columnId, event) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = columnId;
    param['columnValue'] = event;
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {
      this.updateFilterData(columnId);
    });
  }
  // 进度条组件-进度赋值
  setProgressValue() {
    let count = 0;
    this.boardColumnData.forEach((item, index) => {
      if (item.type === 'status' && item.checked || item.type === 'time-interval' && item.checked) {
        count = count + 1;
      }
    });
    let i = count;
    this.boardColumnData.forEach((item, index) => {
      if ((item.type === 'status' || item.type === 'time-interval' ) && item.checked && i >= 0) {
        item.value = this.progressAverage(count)[count - i];
        i = i - 1;
      }
    });
    this.progressCalcValue();
  }
  // 平均分配
  progressAverage(count) {
    const value = [];
    let remainder = 100 % count;
    if (remainder === 0) {
      for (let i = 0; i < count; i++) {
        value.push(100 / count);
      }
    } else {
      for (let i = 0; i < count; i++) {
        if (remainder !== 0) {
          value.push(parseInt(((100 / count) + 1).toString(), 0));
          remainder = remainder - 1;
        } else {
          const num = 100 / count;
          value.push( parseInt(num.toString(), 0) );
        }
      }
    }
    return value;
  }
  // 进度条组件-复选框选中事件
  progressCheckedChange(item) {
    this.progressCheckedId = item.id;
    // 提交
    const param = {
      checked: item.checked,
      value: item.value
    };
    this.dataSubscription = this.taskService.doEditColumnHeader(this.boardId, item.id, param).subscribe((res: any) => {});
  }
  progressCheckboxChange(event) {
    const data = event;
    for (let i = 0; i < this.boardColumnData.length; i++) {
      if (this.boardColumnData[i].type === 'status' || this.boardColumnData[i].type === 'time-interval') {
        this.boardColumnData[i].checked = false;
      }
    }
    if (data.length > 0) {
      for (let i = 0; i < this.boardColumnData.length; i++) {
        if (this.boardColumnData[i].type === 'status' || this.boardColumnData[i].type === 'time-interval') {
          for (let j = 0; j < data.length; j++) {
            if (data[j] === this.boardColumnData[i].id) {
              this.boardColumnData[i].checked = true;
              this.progressSubmitState = false;
            }
          }
        }
      }
    } else {
      for (let j = 0; j < this.boardColumnData.length; j++) {
        if (this.boardColumnData[j].type === 'status' || this.boardColumnData[j].type === 'time-interval') {
          this.boardColumnData[j].checked = false;
          this.progressSubmitState = true;
        }
      }
    }
    this.setProgressValue();
  }
  // 获取当前列
  getCurrendColumn(col) {
    this.currentColumnId = col.id;
  }
  // 进度条组件-提交设置
  submitProgressConfig() {
    let value = 0;
    for (let i = 0; i < this.boardColumnData.length; i++) {
      if (this.boardColumnData[i].type === 'status' && this.boardColumnData[i].checked || this.boardColumnData[i].type === 'time-interval' && this.boardColumnData[i].checked) {
        value = value + Number(this.boardColumnData[i].value);
      }
    }
    if (value > 100) {
      this.message.create('error', '总数不能超过100%！');
      return false;
    } else {
      // 提交
      this.progressCalcValue();
    }
  }

  // 进度条组件-根据进度分配权重计算进度值
  progressCalcValue() {
    const value = []; // 关联列 支持状态、时间区间
    const progressId = []; // 目标进度列
    for (const key in this.boardColumnData) {
      if (this.boardColumnData.hasOwnProperty(key)) {
        if ((this.boardColumnData[key].type === 'status' || this.boardColumnData[key].type === 'time-interval') && this.boardColumnData[key].value && this.boardColumnData[key].checked) {
          const o = {
            key: this.boardColumnData[key].id,
            type: this.boardColumnData[key].type,
            value: Number(this.boardColumnData[key].value)
          };
          value.push(o);
        }
        if (this.boardColumnData[key].type === 'progress') {
          progressId.push(this.boardColumnData[key].id);
        }
      }
    }
    // 处理分组下任务进度
    this.boardGroupData.forEach(group => {
      if (group.pulses) {
        for (let i = 0; i < group.pulses.length; i++) {
          let num = 0;
          for (const key in group.pulses[i].columnValues) {
            if (group.pulses[i].columnValues.hasOwnProperty(key)) {
              for (let j = 0; j < progressId.length; j++) {
                if (progressId[j] === key) {
                  group.pulses[i].columnValues[key] = 0;
                }
              }
            }
          }
          for (let j = 0; j < value.length; j++) {
            switch (value[j].type) {
              case 'status':
                if (group.pulses[i].columnValues[value[j].key] && group.pulses[i].columnValues[value[j].key].index === 2) {
                  num = num + value[j].value;
                  for (const key in group.pulses[i].columnValues) {
                    if (group.pulses[i].columnValues.hasOwnProperty(key)) {
                      for (let k = 0; k < progressId.length; k++) {
                        if (progressId[k] === key) {
                          if (num > 100) {
                            num = 100;
                          } else if (num < 0) {
                            num = 0;
                          }
                          group.pulses[i].columnValues[key] = num;
                        }
                      }
                    }
                  }
                }
                break;
              case 'time-interval':
                if (group.pulses[i].columnValues[value[j].key] && group.pulses[i].columnValues[value[j].key].date && group.pulses[i].columnValues[value[j].key].date.length) {
                  const start: any = new Date(group.pulses[i].columnValues[value[j].key].date[0]);
                  const end: any = new Date(group.pulses[i].columnValues[value[j].key].date[1]);
                  const today: any = new Date();
                  const total = (end - start) / (1000 * 60 * 60 * 24) + 1;
                  const current = (today - start) / (1000 * 60 * 60 * 24) + 1;
                  num += (current / total) * 100;
                  for (const key in group.pulses[i].columnValues) {
                    if (group.pulses[i].columnValues.hasOwnProperty(key)) {
                      for (let k = 0; k < progressId.length; k++) {
                        if (progressId[k] === key) {
                          if (num > 100) {
                            num = 100;
                          } else if (num < 0) {
                            num = 0;
                          }
                          group.pulses[i].columnValues[key] = num.toFixed(0);
                        }
                      }
                    }
                  }
                }
                break;
            }
          }
        }
      }
    });
    // 处理面板任务进度
    for (let i = 0; i < this.boardPulseData.length; i++) {
      let num = 0;
      for (const key in this.boardPulseData[i].columnValues) {
        if (this.boardPulseData[i].columnValues.hasOwnProperty(key)) {
          for (let j = 0; j < progressId.length; j++) {
            if (progressId[j] === key) {
              this.boardPulseData[i].columnValues[key] = 0;
            }
          }
        }
      }
      for (let j = 0; j < value.length; j++) {
        switch (value[j].type) {
          case 'status':
            if (this.boardPulseData[i].columnValues[value[j].key] && this.boardPulseData[i].columnValues[value[j].key].index === 2) {
              num = num + value[j].value;
              for (const key in this.boardPulseData[i].columnValues) {
                if (this.boardPulseData[i].columnValues.hasOwnProperty(key)) {
                  for (let k = 0; k < progressId.length; k++) {
                    if (progressId[k] === key) {
                      if (num > 100) {
                        num = 100;
                      } else if (num < 0) {
                        num = 0;
                      }
                      this.boardPulseData[i].columnValues[key] = num;
                    }
                  }
                }
              }
            }
            break;
          case 'time-interval':
            if (this.boardPulseData[i].columnValues[value[j].key] && this.boardPulseData[i].columnValues[value[j].key].date && this.boardPulseData[i].columnValues[value[j].key].date.length) {
              const start: any = new Date(this.boardPulseData[i].columnValues[value[j].key].date[0]);
              const end: any = new Date(this.boardPulseData[i].columnValues[value[j].key].date[1]);
              const today: any = new Date();
              const total = (end - start) / (1000 * 60 * 60 * 24) + 1;
              const current = (today - start) / (1000 * 60 * 60 * 24) + 1;
              num += (current / total) * 100;
              for (const key in this.boardPulseData[i].columnValues) {
                if (this.boardPulseData[i].columnValues.hasOwnProperty(key)) {
                  for (let k = 0; k < progressId.length; k++) {
                    if (progressId[k] === key) {
                      if (num > 100) {
                        num = 100;
                      } else if (num < 0) {
                        num = 0;
                      }
                      this.boardPulseData[i].columnValues[key] = num.toFixed(0);
                    }
                  }
                }
              }
            }
            break;
        }
      }
    }
  }
  // 列排序
  sortColumn(column, type, group?) {
    if (this.lastColumn && this.lastColumn !== column) {
      this.lastColumn.sort = null;
    }
    this.lastColumn = column;
    if (type !== 'init') {
      if (!column.sort) {
        column.sort = 'asc';
      } else if (column.sort === 'asc') {
        column.sort = 'desc';
      } else {
        column.sort = null;
      }
    }
    const sort = column.sort;
    const columnId = column.id;
    const groupId = group?.id;
    const columnType = column.type;
    // 后台排序
    if (type !== 'init' && groupId) {
      this.taskService.columnSort(groupId, {type: columnType, sort: sort}).subscribe((any) => {});
    }
    if (sort) {
      if (group && group.pulses && group.pulses.length > 0) {
        if (columnType === 'date') {
          group.pulses.sort((a, b) => {
            const va = a.columnValues[columnId];
            const vb = b.columnValues[columnId];
            const date_a = va ? va.date : '';
            const date_b = vb ? vb.date : '';
            if (sort === 'asc') {
              return date_a > date_b ? 1 : (date_b === date_a ? 0 : -1);
            } else {
              return date_a > date_b ? -1 : (date_b === date_a ? 0 : 1);
            }
          });
        } else if (columnType === 'date-time') {
          group.pulses.sort((a, b) => {
            const va = a.columnValues[columnId];
            const vb = b.columnValues[columnId];
            const time_a = va ? (va.date + va.time) : '';
            const time_b = vb ? (vb.date + vb.time) : '';
            if (sort === 'asc') {
              return time_a > time_b ? 1 : (time_b === time_a ? 0 : -1);
            } else {
              return time_a > time_b ? -1 : (time_b === time_a ? 0 : 1);
            }
          });
        } else if (columnType === 'status') {
          group.pulses.sort((a, b) => {
            const va = a.columnValues[columnId];
            const vb = b.columnValues[columnId];
            const status_a = va ? va.index : -1;
            const status_b = vb ? vb.index : -1;
            if (sort === 'asc') {
              return status_a - status_b;
            } else {
              return status_b - status_a;
            }
          });
        } else if (columnType === 'name') {
          console.log("name name")
        }
      }
    } else { // 取消排序
      if (group.pulses) {
        group.pulses.sort((a, b) => {
          return a.createdAt - b.createdAt;
        });
      }
    }
    // if (sort) {
    //   const columnType = column.type;
    //   if (this.boardPulseData && this.boardPulseData.length > 0) {
    //     if (columnType === 'date') {
    //       this.boardPulseData.sort((a, b) => {
    //         const va = a.columnValues[columnId];
    //         const vb = b.columnValues[columnId];
    //         const date_a = va ? va.date : '';
    //         const date_b = vb ? vb.date : '';
    //         if (sort === 'asc') {
    //           return date_a > date_b ? 1 : (date_b === date_a ? 0 : -1);
    //         } else {
    //           return date_a > date_b ? -1 : (date_b === date_a ? 0 : 1);
    //         }
    //       });
    //     } else if (columnType === 'date-time') {
    //       this.boardPulseData.sort((a, b) => {
    //         const va = a.columnValues[columnId];
    //         const vb = b.columnValues[columnId];
    //         const time_a = va ? (va.date + va.time) : '';
    //         const time_b = vb ? (vb.date + vb.time) : '';
    //         if (sort === 'asc') {
    //           return time_a > time_b ? 1 : (time_b === time_a ? 0 : -1);
    //         } else {
    //           return time_a > time_b ? -1 : (time_b === time_a ? 0 : 1);
    //         }
    //       });
    //     } else if (columnType === 'status') {
    //       this.boardPulseData.sort((a, b) => {
    //         const va = a.columnValues[columnId];
    //         const vb = b.columnValues[columnId];
    //         const status_a = va ? va.index : -1;
    //         const status_b = vb ? vb.index : -1;
    //         if (sort === 'asc') {
    //           return status_a - status_b;
    //         } else {
    //           return status_b - status_a;
    //         }
    //       });
    //     }
    //   }
    // } else { // 取消排序
    //   if (this.boardPulseData) {
    //     this.boardPulseData.sort((a, b) => {
    //       return a.createdAt - b.createdAt;
    //     });
    //   }
    // }
  }
  // 删除列
  removeColumn(boardId, columnId) {
    const param = {
      'destroy': true
    };
    this.dataSubscription = this.taskService.doDeleteColumn(boardId, columnId, param).subscribe((res: any) => {
      this.boardColumnData = this.boardColumnData.filter(d => d.id !== columnId);
      // 计算面板宽度
      this.calcBoardWidth();
      this.setProgressValue();
      this.removeFilterColumn(columnId);
    });
  }
  // 删除行
  removePulse(pulseId, groupId) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['isDelete'] = true;
    this.dataSubscription = this.taskService.doDeletePulse(param).subscribe((res: any) => {
      this.boardPulseData = this.boardPulseData.filter(d => d.id !== pulseId);
      this.boardGroupData.forEach(group => {
        if (group.id === groupId) {
          group.pulses = group.pulses.filter(d => d.id !== pulseId);
        }
      });
    });
    // 重新计算选中
    if (this.pulseCheckedData && this.pulseCheckedData.pulseIds) {
      for (let i = 0; i < this.pulseCheckedData.pulseIds.length; i++) {
        if (this.pulseCheckedData.pulseIds[i] === pulseId) {
          this.pulseCheckedData.pulseIds.splice(i, 1);
        }
      }
    }
    // this.nfUpdateTable.emit(true);
  }
  // 删除组
  removeGroup(boardId, groupId) {
    const param = {
      'destroy': true
    };
    this.dataSubscription = this.taskService.doDeleteGroup(boardId, groupId, param).subscribe((res: any) => {
      this.boardGroupData = this.boardGroupData.filter(d => d.id !== groupId);
      this.pulseCheckedId = [];
    });
  }
  // 批量编辑
  batchEditPulse() {
    this.tplModal = this.modal.create({
      nzContent: this.modalTplContent,
      nzMaskClosable: false,
      nzFooter: this.tplFooter,
      nzTitle: null,
      nzWidth: '30%',
      nzWrapClassName: 'vertical-center-modal',
    });
  }
  // 批量编辑弹窗按钮事件
  handleAddCancel() {
    this.tplModal.destroy();
  }
  handleAddOk() {
    this.pulseCard.onSubmit();
  }
  getPulseCardData(data) {
    if (data.columnValues && data.columnValues.length > 0) {
      this.isConfirmLoading = true;
      this.dataSubscription = this.taskService.batchChangeColumn(this.boardId, data).subscribe((res: any) => {
        this.isConfirmLoading = false;
        this.message.create('success', '更新成功！');
        this.nfUpdateTable.emit(true);
        this.tplModal.destroy();
        this.pulseCheckedId = [];
      }, (err) => {
        this.isConfirmLoading = false;
        this.message.create('error', '更新失败！');
      });
    } else {
      this.message.create('info', '无修改项！');
    }
  }
  // 批量归档
  batchArchivePulse() {
    this.confirmModal = this.modal.confirm({
      nzTitle: '是否确认归档?',
      nzWrapClassName: 'vertical-center-modal',
      nzOnOk: () => {
        const param = {};
        param['pulseIds'] = this.pulseCheckedData.pulseIds;
        this.dataSubscription = this.taskService.doDeletePulse(param).subscribe((res: any) => {
          for (let i = 0; i < this.pulseCheckedData.pulseIds.length; i++) {
            this.boardPulseData = this.boardPulseData.filter(d => d.id !== this.pulseCheckedData.pulseIds[i]);
            this.boardGroupData.forEach(group => {
              group.pulses = group.pulses.filter(d => d.id !== this.pulseCheckedData.pulseIds[i]);
            });
          }
          this.closeBatchMenu();
        });
      }
    });
  }
  // 批量删除行
  batchDeletePulse() {
    this.confirmModal = this.modal.confirm({
      nzTitle: '是否确认删除?',
      nzWrapClassName: 'vertical-center-modal',
      nzOnOk: () => {
        this.dataSubscription = this.taskService.doDeletePulse(this.pulseCheckedData).subscribe((res: any) => {
          for (let i = 0; i < this.pulseCheckedData.pulseIds.length; i++) {
            this.boardPulseData = this.boardPulseData.filter(d => d.id !== this.pulseCheckedData.pulseIds[i]);
          }
          this.nfUpdateTable.emit(true);
          this.closeBatchMenu();
        });
      }
    });
  }
  // 归档组
  archiveGroup(boardId, groupId) {
    this.dataSubscription = this.taskService.doDeleteGroup(boardId, groupId, {}).subscribe((res: any) => {
      this.boardGroupData = this.boardGroupData.filter(d => d.id !== groupId);
    });
  }
  // 归档行
  archivePulse(pulseId, groupId) {
    const param = {};
    param['pulseIds'] = [pulseId];
    this.dataSubscription = this.taskService.doDeletePulse(param).subscribe((res: any) => {
      this.boardPulseData = this.boardPulseData.filter(d => d.id !== pulseId);
      this.boardGroupData.forEach(group => {
        if (group.id === groupId) {
          group.pulses = group.pulses.filter(d => d.id !== pulseId);
        }
      });
    });
    // 重新计算选中
    if (this.pulseCheckedData && this.pulseCheckedData.pulseIds) {
      for (let i = 0; i < this.pulseCheckedData.pulseIds.length; i++) {
        if (this.pulseCheckedData.pulseIds[i] === pulseId) {
          this.pulseCheckedData.pulseIds.splice(i, 1);
        }
      }
    }
    // this.nfUpdateTable.emit(true);
  }
  // 点击当前列显示状态切换
  clickCurrentColumn(columnId, groupId) {
    this.clickCurrentColumnValue = columnId + groupId;
  }
  // 点击当前行显示状态切换
  clickCurrentPulse(pulseId) {
    this.clickCurrentPulseValue = pulseId;
  }
  //  监听滚动条
  listenerScroll() {
    const scrollContainer = document.getElementById('first-level-content');
    if (scrollContainer) {
      this.subscribeScoll = fromEvent(scrollContainer, 'scroll')
        .subscribe((event) => {
          this.onWindowScroll(scrollContainer);
        });
    }
  }
  // 滚动条事件
  onWindowScroll(scrollContainer) {
    scrollContainer.scrollLeft > 0 ? this.showColumnShadow = true : this.showColumnShadow = false;
  }
  // 拖动改变列宽
  validate(event: ResizeEvent): boolean {
    const MIN_DIMENSIONS_PX = 50;
    if (
      event.rectangle.width &&
      event.rectangle.height &&
      (event.rectangle.width < MIN_DIMENSIONS_PX ||
        event.rectangle.height < MIN_DIMENSIONS_PX)
    ) {
      return false;
    }
    return true;
  }
  onResizing(event: ResizeEvent, column): void {
    if (this.boardData.boardData && this.boardData.boardData.currentUser
      && this.boardData.boardData.currentUser.permissions && this.boardData.boardData.currentUser.permissions.includes('owner')) {
      column.width = event.rectangle.width;
      this.taskService.doEditColumnHeader(this.boardId, column.id, {width: column.width}).subscribe(res => {});
      this.calcBoardWidth();
    }
  }
  // 行复选框事件
  updatePulseChecked(event, pulseId) {
    if (event) {
      this.pulseCheckedId.push(pulseId);
      const o = {
        isDelete: true,
        pulseIds: this.pulseCheckedId
      };
      this.pulseCheckedData = o;
    } else {
      for (let i = 0; i < this.pulseCheckedData.pulseIds.length; i++) {
        if (this.pulseCheckedData.pulseIds[i] === pulseId) {
          this.pulseCheckedData.pulseIds.splice(i, 1);
        }
      }
    }
  }
  // 关闭批量操作浮动菜单
  closeBatchMenu() {
    this.pulseCheckedId = [];
    this.pulseCheckedData.pulseIds = [];
    this.boardPulseData.forEach((item, index) => {
      item.isDelete = false;
    });
    this.boardGroupData.forEach(g => {
      g.pulses.forEach(p => {
        p.isDelete = false;
      });
    });
  }
  // 打开会话抽屉
  clickChoseDropdownOption() {
  }
  openDialog(boardId, column, pulse) {
    this.isDialogVisible = true;
    this.conversationBaseData = {
      'boardId': boardId,
      'column': column,
      'pulse': pulse,
      'currentUser': this.boardData.boardData.currentUser,
      'permissionDefinition': this.boardData.permissionDefinition
    };
  }
  closeDialog() {
    this.isDialogVisible = false;
  }
  // 折叠当前组
  collapseGroup(groupId) {
    this.collapseGroups.push(groupId);
    this.handleGroupData();
    const param = {'collapse': 'true'};
    this.dataSubscription = this.taskService.setCollapseState(this.boardId, groupId, param).subscribe((res: any) => {});
  }
  // 折叠所有组
  collapseAllGroup() {
    this.collapseGroups = [];
    this.boardGroupData.forEach((item, index) => {
      this.boardGroupData[index].collapse = 'true';
      this.collapseGroups.push(item.id);
    });
    const param = {'collapse': 'true'};
    this.dataSubscription = this.taskService.setAllCollapseState(this.boardId, param).subscribe((res: any) => {});
  }
  unfoldAllGroup() {
    this.boardGroupData.forEach((item, index) => {
      this.boardGroupData[index].collapse = 'false';
      this.boardGroupData[index].menuPopVisible = false;
    });
    const param = {'collapse': 'false'};
    this.dataSubscription = this.taskService.setAllCollapseState(this.boardId, param).subscribe((res: any) => {});
  }
  // 选中组
  selectGroup(group) {
    this.boardGroupData.forEach(g => {
      if (g.id === group.id) {
        g.pulses.forEach(p => {
          p.isDelete = true;
        });
      }
    });
    const groupPulses = this.boardPulseData.filter(item => group.id === item.groupId);
    for (const pulse of groupPulses) {
      if (!this.pulseCheckedId.includes(pulse.id)) {
        this.pulseCheckedId.push(pulse.id);
        pulse.isDelete = true;
      }
    }
    this.pulseCheckedData = {
      isDelete: true,
      pulseIds: this.pulseCheckedId
    };
    group.menuPopVisible = false;
  }
  // 展开当前组
  openGroup(groupId) {
    this.boardGroupData.forEach((item, index) => {
      if (item.id === groupId) {
        this.boardGroupData[index].collapse = 'false';
      }
    });
    this.collapseGroups = this.collapseGroups.filter(id => id !== groupId);
    const param = {'collapse': 'false'};
    this.dataSubscription = this.taskService.setCollapseState(this.boardId, groupId, param).subscribe((res: any) => {});
  }
  // 处理折叠组数据
  handleGroupData() {
    this.boardGroupData.forEach((item, index) => {
      for (let i = 0; i < this.collapseGroups.length; i++) {
        if (item.id === this.collapseGroups[i]) {
          this.boardGroupData[index].collapse = 'true';
        }
      }
    });
  }
  groupAuthorityChange(groupId, visible) {
    if (visible) {
      this.taskService.getGroupAuthority(this.boardId, groupId).subscribe(res => {
        if (res) {
          this.groupAuthority = res;
        }
      });
    }
  }
  getAuthorityMember(target, value) {
    target.members = value;
  }
  groupAuthorityConfirm(group) {
    this.taskService.setGroupAuthority(this.boardId, group.id, this.groupAuthority).subscribe(res => {
      if (res) {
        group['visible'] = false;
      } else {
        this.message.error('提交失败！');
      }
    });
  }
  // 按钮组件-按钮配置pop框
  openButtonConfig(pulseId, column) {
    this.clickCurrentPulseValue = pulseId;
    this.buttonConfigStatus = true;
    // 设置无法删除标识
    const userIds = this.getButtonUserIds(column);
    if (column.config.original && column.config.original.length > 0) {
      column.config.original.forEach((item, index) => {
        item.notRemove = false;
        for (let i = 0; i < userIds.length; i++) {
          if (item.id === userIds[i]) {
            item.notRemove = true;
          }
        }
      });
    }
  }
  // 按钮组件-删除
  removeButtonConfig(itemId, column) {
    column.config.original = column.config.original.filter(item => item.id !== itemId);
  }
  // 按钮组件-编辑
  editButtonConfig(item) {
    this.buttonConfigEditeData = item;
    this.buttonConfigStatus = !this.buttonConfigStatus;
    this.buttonConfigEditStatus = true;
    this.buttonConfigTitle = item.title;
    this.buttonConfigDisabled = item.usable;
    this.buttonConfigUrl = item.url;
  }
  // 按钮配置新增/编辑事件
  buttonConfigAdd() {
    this.buttonConfigTitle = null;
    this.buttonConfigDisabled = true;
    this.buttonConfigUrl = null;
    this.buttonConfigStatus = !this.buttonConfigStatus;
    this.buttonConfigEditStatus = false;
  }
  buttonConfigChange(event) {
    this.buttonConfigDisabled = event;
  }
  // 按钮配置提交
  buttonConfigSubmit(type, column) {
    if (!this.buttonConfigTitle) {
      this.message.create('error', '请输入按钮名称');
    } else {
      if (type === 'add') {
        const maxId = this.getMaxId(column.config.original) + 1;
        const addObj = {
          'id': maxId,
          'title': this.buttonConfigTitle,
          'type': 'primary',
          'usable': this.buttonConfigDisabled,
          'url': this.buttonConfigUrl,
          'isExternalUrl': this.isExternalUrl
        };
        column.config.original = [
          ...column.config.original,
          addObj
        ];
      } else if (type === 'edit') {
        column.config.original.forEach((item, index) => {
          if (item.id === this.buttonConfigEditeData.id) {
            item.title = this.buttonConfigTitle;
            item.usable = this.buttonConfigDisabled;
            item.url = this.buttonConfigUrl;
            item.isExternalUrl = this.isExternalUrl;
          }
        });
      }
      const param = {
        'config': column.config
      };
      this.dataSubscription = this.taskService.doEditColumnHeader(this.boardId, column.id, param).subscribe((res: any) => {});
      this.buttonConfigStatus = !this.buttonConfigStatus;
    }
  }
  // 获取按钮ID
  getMaxId(data) {
    const ids = [];
    if (data && data.length > 0) {
      data.forEach((item, index) => {
        ids.push(item.id);
      });
      return ids.reduce((a, b) => {
        return b > a ? b : a;
      });
    } else {
      return 0;
    }
  }
  // 按钮组件-获取所有按钮已用ID
  getButtonUserIds(column) {
    let useIds = [];
    this.boardPulseData.forEach((pulses, index) => {
      for (const item in pulses.columnValues) {
        if (pulses.columnValues.hasOwnProperty(item)) {
          if (pulses.columnValues[column.id].original) {
            useIds.push(pulses.columnValues[column.id].original);
          }
        }
      }
    });
    useIds = Array.from(new Set(useIds));
    return useIds;
  }
  // 按钮组件-配置关联
  buttonRelationChange(event, column) {
    column.config.relation = event;
    const param = {
      'config': column.config
    };
    this.dataSubscription = this.taskService.doEditColumnHeader(this.boardId, column.id, param).subscribe((res: any) => {});
  }
  buttonSelectChange(event, pulseId, column) {
    const param = {};
    param['pulseIds'] = [pulseId];
    param['columnId'] = column.id;
    param['columnValue'] = {
      'original': event
    };
    this.dataSubscription = this.taskService.doEditPulse(this.boardId, param).subscribe((res: any) => {});
  }
  // 按钮组件-自定义按钮点击事件
  buttonCustomClick(column, pulse) {
    let isExternalUrl = false;
    let url = '';
    column.config.original.forEach((item, index) => {
      if (item.id.toString() === pulse.columnValues[column.id].original.toString()) {
        url = item.url;
        isExternalUrl = item.isExternalUrl;
      }
    });
    const param = {
      'pulseId': pulse.id,
      'columnId': column.id
    };
    this.clickButtonLoading = true;
    this.dataSubscription = this.taskService.buttonClickEvent(url, param, isExternalUrl).subscribe((res: any) => {
      this.nfUpdateTable.emit(true);
      this.clickButtonLoading = false;
    }, (err) => {
      this.clickButtonLoading = false;
    });
  }
  // 按钮组件-关联按钮点击事件
  buttonRelationClick(url, pulseId) {
    // todo 后台交互
    console.log(url + pulseId)
  }
  // 选择器组件-选项变更回调
  selectOptionChange(event) {
    // todo 后台交互
  }
  // 列权限控制
  columnPermissionSet(type, columnId, state) {
    const param = {};
    param[type] = state;
    if (type === 'lock') {
      this.dataSubscription = this.taskService.setLockState(this.boardId, columnId, param).subscribe((res: any) => {
        this.handleColumnPermission(type, columnId, state);
      });
    } else if (type === 'hide') {
      this.dataSubscription = this.taskService.setHideState(this.boardId, columnId, param).subscribe((res: any) => {
        this.handleColumnPermission(type, columnId, state);
      });
    }
  }
  columnSetting(column, boardId) {
    column.configs = {
      relationData: {
        boardId: boardId
      }
    };
    this.taskService.doEditColumnHeader(this.boardId, column.id, column).subscribe();
    if (this.boardPulseData) {
      const pulseIds = [];
      for (const pulse of this.boardPulseData) {
        pulse.columnValues[column.id] = {};
        pulseIds.push(pulse.id);
      }
      const param = {
        columnId: column.id,
        columnValue: {},
        pulseIds: pulseIds
      };
      this.taskService.doEditPulse(this.boardId, param).subscribe();
    }
  }
  // 处理列权限
  handleColumnPermission(type, columnId, state) {
    this.boardColumnData.forEach((item, index) => {
      if (item.id === columnId) {
        this.boardColumnData[index].permissionType = state === 'false' ? null : type;
        this.boardColumnData[index].permittedUserIds = [];
      }
    });
  }
  // 列加密状态切换
  columnEncryptChange(column) {
    let state = null;
    if (!column.encrypt) {
      state = 'true';
    }
    if (column.encrypt === 'true') {
      state = 'false';
    } else if (column.encrypt === 'false') {
      state = 'true';
    }
    this.handleColumnEncrypt(column.id, state);
  }
  // 列加密数据处理
  handleColumnEncrypt(columnId, state) {
    this.boardColumnData.forEach((item, index) => {
      if (item.id === columnId) {
        item.encrypt = state;
      }
    });
    const param = {
      'encrypt': state
    };
    this.dataSubscription = this.taskService.setColumnEncrypt(this.boardId, columnId, param).subscribe((res: any) => {
      this.message.create('success', '设置成功！');
    });
  }
  // 成员选择
  columnSelectMember(column) {
   this.isMemberVisible = true;
   this.currentColumnData = column;
  }
  handleMemberCancel() {
    this.isMemberVisible = false;
    this.currentColumnData = null;
  }

  // 计算筛选数据
  calcFilterData() {
    this.filterData = {
      groups: [],
      groupLabels: [],
      selectedLabels: [],
      selectedGroups: [],
      columns: []
    };
    if (this.boardData) {
      for (const group of this.boardGroupData) {
        this.filterData.groups.push({groupId: group.id, name: group.title, color: group.color});
      }
      for (const column of this.boardColumnData) {
        if (this.filterColumnExclude.includes(column.type)) { continue; }
        const columnValues = this.generateColumnValue(column);
        this.filterData.columns.push({
          columnId: column.id,
          type: column.type,
          name: column.title,
          maxHeight: '240px',
          valueMaxHeight: '',
          columnValues: columnValues,
          selectedValue: []
        });
      }
    }
  }

  updateFilterData(columnId) {
    let column: any = {};
    for (const item of this.boardColumnData) {
      if (item.id == columnId) {
        column = item;
        break;
      }
    }
    const columnValues = this.generateColumnValue(column);
    let filterColumn: any = {};
    for (const item of this.filterData.columns) {
      if (item.columnId == columnId) {
        filterColumn = item;
        break;
      }
    }
    filterColumn.columnValues.forEach(item => item.exist = false);
    filterColumn.selectedValue.forEach(item => item.exist = false);
    if (column.type == 'link') {
      filterColumn.selectedValue = filterColumn.selectedValue.filter(item => {
        return columnValues.findIndex(value => value.value == item.value && value.title == item.title) > -1;
      });
      for (const item of columnValues) {
        item['exist'] = true;
        let flag = false;
        if (this.isExist(filterColumn.columnValues, item, 'value', 'title')) {
          flag = true;
          const index = filterColumn.columnValues.findIndex(value => value.value == item.value && value.title == item.title);
          filterColumn.columnValues[index] = item;
        }
        if (!flag) {
          if (this.isExist(filterColumn.selectedValue, item, 'value', 'title')) {
            const index = filterColumn.selectedValue.findIndex(value => value.value == item.value && value.title == item.title);
            filterColumn.selectedValue[index] = item;
          } else {
            filterColumn.columnValues.push(item);
          }
        }
      }
    } else {
      filterColumn.selectedValue = filterColumn.selectedValue.filter(item => {
        return columnValues.findIndex(value => value.value == item.value) > -1;
      });
      for (const item of columnValues) {
        item['exist'] = true;
        let flag = false;
        if (this.isExist(filterColumn.columnValues, item, 'value')) {
          flag = true;
          const index = filterColumn.columnValues.findIndex(value => value.value == item.value);
          filterColumn.columnValues[index] = item;
        }
        if (!flag) {
          if (this.isExist(filterColumn.selectedValue, item, 'value')) {
            const index = filterColumn.selectedValue.findIndex(value => value.value == item.value);
            filterColumn.selectedValue[index] = item;
          } else {
            filterColumn.columnValues.push(item);
          }
        }
      }
    }
    filterColumn.columnValues = filterColumn.columnValues.filter(item => item.exist);
    filterColumn.selectedValue = filterColumn.selectedValue.filter(item => item.exist);
  }

  removeFilterColumn(columnId) {
    const index = this.filterData.columns.findIndex(item => item.columnId == columnId);
    this.filterData.columns.splice(index, 1);
    this.filter();
  }

  addFilterColumn(source) {
    if (this.filterColumnExclude.includes(source.type)) {
      return;
    }
    this.filterData.columns.push({
      columnId: source.id,
      type: source.type,
      name: source.title,
      maxHeight: '240px',
      valueMaxHeight: '',
      columnValues: [{title: '', value: '', count: this.boardPulseData.length}],
      selectedValue: []
    });
  }

  generateColumnValue(column) {
    const columnValues = [];
    for (const pulse of this.boardData.boardData.pulses) {
      let o = {title: '', value: '', count: 1};
      const pulseValues = pulse.columnValues;
      switch (column.type) {
        case 'date-time':
        case 'date':
          const cellValue = pulseValues[column.id] && pulseValues[column.id]['date'] ? pulseValues[column.id]['date'] : '';
          o = {
            title: cellValue,
            value: cellValue,
            count: 1
          };
          if (!this.isExist(columnValues, o, 'value')) {
            columnValues.push(o);
          }
          break;
        case 'file':
          if (pulseValues[column.id] && pulseValues[column.id]['files'] && pulseValues[column.id]['files'].length > 0) {
            for (const file of pulseValues[column.id]['files']) {
              o = {title: file.name, value: file.name, count: 1};
              if (!this.isExist(columnValues, o, 'value')) {
                columnValues.push(o);
              }
            }
          } else {
            if (!this.isExist(columnValues, o, 'value')) {
              columnValues.push(o);
            }
          }
          break;
        case 'link':
          o = {
            title: pulseValues[column.id] ? pulseValues[column.id]['name'] : '',
            value: pulseValues[column.id] ? pulseValues[column.id]['url'] : '',
            count: 1
          };
          if (!this.isExist(columnValues, o, 'value', 'title')) {
            columnValues.push(o);
          }
          break;
        case 'name':
        case 'text':
          const textValue = pulseValues[column.id] || '';
          o = {title: textValue, value: textValue, count: 1};
          if (!this.isExist(columnValues, o, 'value')) {
            columnValues.push(o);
          }
          break;
        case 'multiple-person':
          if (pulseValues[column.id] && pulseValues[column.id]['personsAndTeams'] && pulseValues[column.id]['personsAndTeams'].length > 0) {
            for (const person of pulseValues[column.id]['personsAndTeams']) {
              o = {title: person.name, value: person.id, count: 1};
              if (!this.isExist(columnValues, o, 'value')) {
                columnValues.push(o);
              }
            }
          } else {
            if (!this.isExist(columnValues, o, 'value')) {
              columnValues.push(o);
            }
          }
          break;
        case 'status':
          let label = '';
          let color = '';
          if (pulseValues[column.id]) {
            const labels = column.labels;
            for (const l of labels) {
              if (l.index == pulseValues[column.id]['index']) {
                label = l.label;
                color = l.color;
                break;
              }
            }
          }
          o = {
            title: label,
            value: pulseValues[column.id] ? pulseValues[column.id]['index'] : '',
            count: 1
          };
          o['color'] = color;
          if (!this.isExist(columnValues, o, 'value')) {
            columnValues.push(o);
          }
          break;
        case 'dropdown':
          if (pulseValues[column.id] && pulseValues[column.id]['ids'] && pulseValues[column.id]['ids'].length > 0) {
            if (column.settings && column.settings.labels) {
              for (const id of pulseValues[column.id]['ids']) {
                for (const label of column.settings.labels) {
                  if (id == label.id) {
                    o = {title: label.name, value: id, count: 1};
                    if (!this.isExist(columnValues, o, 'value')) {
                      columnValues.push(o);
                    }
                    break;
                  }
                }
              }
            }
          } else {
            if (!this.isExist(columnValues, o, 'value')) {
              columnValues.push(o);
            }
          }
          break;
        case 'select':
          if (pulseValues[column.id] && pulseValues[column.id]['option'] && column.config && column.config.option) {
            for (const option of column.config.option) {
              if (option.id == pulseValues[column.id]['option']) {
                o = {title: option.title, value: option.id, count: 1};
                if (!this.isExist(columnValues, o, 'value')) {
                  columnValues.push(o);
                }
                break;
              }
            }
          } else {
            if (!this.isExist(columnValues, o, 'value')) {
              columnValues.push(o);
            }
          }
          break;
        case 'check':
          if (pulseValues[column.id] == 'true') {
            o.title = '✔';
            o.value = 'true';
          }
          if (!this.isExist(columnValues, o, 'value')) {
            columnValues.push(o);
          }
          break;
      }
    }
    return columnValues;
  }

  useLastCondition() {
    const condition = localStorage.getItem(this.boardId);
    if (condition) {
      this.filterData = JSON.parse(condition);
      this.filter();
    } else {
      this.message.info('未查询到上次筛选配置');
    }
  }

  clearFilterCondition() {
    this.boardGroupData = this.boardData.boardData.groups || [];
    this.boardPulseData = this.boardData.boardData.pulses || [];
    this.filterData.selectedGroups.forEach(item => {
      this.filterData.groups.push(item);
    });
    this.filterData.selectedLabels.forEach(item => {
      this.filterData.groupLabels.push(item);
    });
    this.filterData.selectedLabels = [];
    this.filterData.selectedGroups = [];
    this.filterData.columns.forEach(column => {
      column.selectedValue.forEach(value => {
        column.columnValues.push(value);
      });
      column.selectedValue = [];
    });
  }

  chooseGroup(group, i) {
    this.filterData.selectedGroups.push(group);
    this.filterData.groups.splice(i, 1);
    this.filter();
  }

  removeGroupFilter(group, i) {
    this.filterData.groups.push(group);
    this.filterData.selectedGroups.splice(i, 1);
    this.filter();
  }
  // 分组标签筛选
  chooseGroupLabel(group, i) {
    this.filterData.selectedLabels.push(group);
    this.filterData.groupLabels.splice(i, 1);
    this.filter();
  }
  removeGroupLabelFilter(group, i) {
    this.filterData.groupLabels.push(group);
    this.filterData.selectedLabels.splice(i, 1);
    this.filter();
  }

  chooseValue(column, value, index) {
    column.columnValues.splice(index, 1);
    column.selectedValue.push(value);
    this.calcHeight(column);
    this.filter();
  }

  removeValue(column, value, index) {
    column.columnValues.push(value);
    column.selectedValue.splice(index, 1);
    this.calcHeight(column);
    this.filter();
  }

  calcHeight(column) {
    if (column.selectedValue.length === 0) {
      column.maxHeight = '240px';
    } else if (column.selectedValue.length === 1) {
      column.maxHeight = '184px';
    } else if (column.selectedValue.length === 2) {
      column.maxHeight = '148px';
    } else if (column.selectedValue.length === 3) {
      column.maxHeight = '112px';
    } else if (column.selectedValue.length > 3 && column.columnValues.length == 3) {
      column.valueMaxHeight = '112px';
    } else if (column.selectedValue.length > 3 && column.columnValues.length == 2) {
      column.valueMaxHeight = '148px';
    } else if (column.selectedValue.length > 3 && column.columnValues.length == 1) {
      column.valueMaxHeight = '184px';
    } else if (column.selectedValue.length > 3 && column.columnValues.length == 0) {
      column.valueMaxHeight = '240px';
    } else {
      column.maxHeight = '110px';
      column.valueMaxHeight = '110px';
    }
  }

  filter() {
    const groupLabelSet = new Set();
    const groupSet = new Set();
    const pulses = [];
    const groupIds = [];
    const groupLabels = [];
    for (const group of this.filterData.selectedGroups) {
      groupIds.push(group.groupId);
    }
    for (const label of this.filterData.selectedLabels) {
      groupLabels.push(label.name);
    }
    if (this.boardData.boardData.pulses && this.boardData.boardData.pulses.length > 0) {
      for (const pulse of this.boardData.boardData.pulses) {
        if (groupIds.length > 0 && !groupIds.includes(pulse.groupId)) {
          continue;
        }
        let flag = true;
        if (this.filterData.columns.length > 0) {
          for (const filterColumn of this.filterData.columns) {
            const values = [];
            for (const item of filterColumn.selectedValue) {
              if (filterColumn.type === 'link') {
                values.push(item);
              } else {
                values.push(item.value);
              }
            }
            if (values.length > 0) {
              let cellValue = pulse.columnValues[filterColumn.columnId];
              switch (filterColumn.type) {
                case 'date-time':
                case 'date':
                  const v = cellValue && cellValue['date'] ? cellValue['date'] : '';
                  flag = values.includes(v);
                  break;
                case 'file':
                  if (cellValue && cellValue['files'] && cellValue['files'].length > 0) {
                    let fileFlag = false;
                    for (const file of cellValue['files']) {
                      fileFlag = fileFlag || values.includes(file.name);
                    }
                    flag = fileFlag;
                  } else {
                    flag = values.includes('');
                  }
                  break;
                case 'link':
                  flag = cellValue && (values.findIndex(item => item.value === cellValue['url'] && item.title === cellValue['name']) > -1);
                  break;
                case 'name':
                case 'text':
                  cellValue = cellValue || '';
                  flag = values.includes(cellValue);
                  break;
                case 'multiple-person':
                  if (cellValue && cellValue['personsAndTeams'] && cellValue['personsAndTeams'].length > 0) {
                    let personFlag = false;
                    for (const person of cellValue['personsAndTeams']) {
                      personFlag = personFlag || values.includes(person.id);
                    }
                    flag = personFlag;
                  } else {
                    flag = values.includes('');
                  }
                  break;
                case 'status':
                  flag = values.includes(cellValue['index']);
                  break;
                case 'dropdown':
                  if (cellValue && cellValue['ids'] && cellValue['ids'].length > 0) {
                    let dropFlag = false;
                    for (const id of cellValue['ids']) {
                      dropFlag = dropFlag || values.includes(id);
                    }
                    flag = dropFlag;
                  } else {
                    flag = values.includes('');
                  }
                  break;
                case 'select':
                  flag = values.includes(cellValue['option']);
                  break;
                case 'check':
                  for (const value of values) {
                    if (value === 'true') {
                      flag = value === cellValue;
                    } else {
                      flag = (cellValue === '\"true\"' || cellValue === 'false');
                    }
                    if (flag) {
                      break;
                    }
                  }
                  break;
              }
              if (!flag) {
                break;
              }
            }
          }
        }
        if (flag) {
          // 处理标签分组筛选
          let label = [];
          this.boardGroupData.forEach(item => {
            if (pulse.groupId === item.id) {
              if (item.label) {
                const arr = item.label.split(',');
                label = label.concat(arr);
              }
            }
          });
          label.forEach(_lab => {
            groupLabelSet.add(_lab);
          });
          groupSet.add(pulse.groupId);
          pulses.push(pulse);
        }
      }
    }
    // 筛选分组
    this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups.filter((item) => {
      return groupIds.length > 0 ? groupIds.includes(item.id) && groupSet.has(item.id) : true;
    }) : [];
    // 筛选分组标签
    this.boardGroupData = this.boardData.boardData.groups ? this.boardData.boardData.groups.filter((item) => {
      let status = false;
        if (item.label) {
          const arr = item.label.split(',');
          arr.forEach(_a => {
            if (groupLabels.includes(_a)) {
              status = true;
            }
          });
        }
        if (groupLabels.length === 0) {
          status = true;
        }
      return status;
    }) : [];
    this.boardPulseData = pulses;
    this.boardGroupData.forEach(_g => {
      _g.pulses = [];
      pulses.forEach(_p => {
        if (_p.groupId === _g.id) {
          _g.pulses.push(_p);
        }
      });
    });
    localStorage.setItem(this.boardId, JSON.stringify(this.filterData));
  }

  isExist(arr: Array<any>, obj, attr, attr2?): boolean {
    for (const item of arr) {
      if (item[attr] === obj[attr]) {
        if (attr2) {
          if (item[attr2] === obj[attr2]) {
            item.count++;
            return true;
          }
        } else {
          item.count++;
          return true;
        }
      }
    }
    return false;
  }

  moveToGroup(group) {
    this.taskService.moveToGroup(this.boardId, {groupId: group.id, pulseIds: this.pulseCheckedId}).subscribe(res => {
      if (res) {
        for (const pulse of this.boardPulseData) {
          if (this.pulseCheckedId.includes(pulse.id)) {
            pulse.groupId = group.id;
          }
        }
        this.closeBatchMenu();
      } else {
        this.message.error('移至分组失败!');
      }
    });
    this.nfUpdateTable.emit(true);
  }
  // 批量设置成员
  batchSettingMember(columnId) {
    this.currentColumnId = columnId;
    this.isBatchAddMemberVisible = true;
    this.selectedMemberValue = [];
    this.selectedTaskValue = [];
    this.onMemberSearch('');
    if (this.currentUser) {
      this.selectedMemberValue = [...this.selectedMemberValue, this.currentUser];
    }
  }
  // 批量追加成员
  batchAttachMember(columnId) {
    this.currentColumnId = columnId;
    this.batchAttachMemberVisible = true;
    this.selectedMemberValue = [];
    this.onMemberSearch('');
  }
  // 批量更新人员请求
  batchUpdateBoardMember(boardId, param) {
    this.taskService.batchAttachUser(boardId, param).subscribe(res => {
      if (res) {
        this.message.success('设置成功');
      } else {
        this.message.success('设置失败');
      }
      this.isBatchAddMemberVisible = false;
    });
  }
  handleBatchAddMemberCancel() {
    this.isBatchAddMemberVisible = false;
  }
  handleBatchAttachOk() {
    const changeValues = [];
    this.selectedTaskValue.forEach(taskId => {
      // 处理GroupPulses
      this.boardGroupData.forEach(g => {
        g.pulses.forEach(item => {
          if (item.id === taskId) {
            if (item.columnValues[this.currentColumnId] && item.columnValues[this.currentColumnId].personsAndTeams) {
              item.columnValues[this.currentColumnId].personsAndTeams.push(...this.selectedMemberValue);
              const obj = {};
              item.columnValues[this.currentColumnId].personsAndTeams = item.columnValues[this.currentColumnId].personsAndTeams.reduce((cur, next) => {
                obj[next.id] ? '' : obj[next.id] = true && cur.push(next);
                return cur;
              }, []);
            } else {
              item.columnValues[this.currentColumnId] = {
                personsAndTeams: this.selectedMemberValue
              };
            }
            changeValues.push({
              pulseIds: [taskId],
              columnId: this.currentColumnId,
              columnValue: item.columnValues[this.currentColumnId]
            });
          }
        });
      });
      // 处理Pulses
      this.boardPulseData.forEach(item => {
        if (item.id === taskId) {
          if (item.columnValues[this.currentColumnId] && item.columnValues[this.currentColumnId].personsAndTeams) {
            item.columnValues[this.currentColumnId].personsAndTeams.push(...this.selectedMemberValue);
            const obj = {};
            item.columnValues[this.currentColumnId].personsAndTeams = item.columnValues[this.currentColumnId].personsAndTeams.reduce((cur, next) => {
              obj[next.id] ? '' : obj[next.id] = true && cur.push(next);
              return cur;
            }, []);
          } else {
            item.columnValues[this.currentColumnId] = {
              personsAndTeams: this.selectedMemberValue
            };
          }
          changeValues.push({
            pulseIds: [taskId],
            columnId: this.currentColumnId,
            columnValue: item.columnValues[this.currentColumnId]
          });
          // if (item.columnValues[this.currentColumnId]) {
          // }
        }
      });
    });
    if (changeValues.length > 0) {
      this.batchUpdateBoardMember(this.boardId, changeValues);
    }
  }
  // 下拉加载更多
  loadMore(): void {
    if (this.loadMoreData) {
      this.randomUserUrl = this.taskService.getBoardUser(this.boardId);
      const param = {
        size: this.pageSize.toString(),
        page: this.pageIndex.toString()
      };
      this.getBoardUserList = this.http
        .get(`${this.randomUserUrl}`, {params: param})
        .pipe(map((res: any) => res))
        .pipe(
          map((list: any) => {
            return list;
          })
        );
      this.isLoading = true;
      this.getBoardUserList.subscribe(data => {
        this.isLoading = false;
        if (data) {
          const newData = data.users && data.users.data ? data.users.data : [];
          this.memberList = [...this.memberList, ...newData];
          if (this.pageIndex >= data.users.page.totalPages) {
            this.loadMoreData = false;
            return;
          }
          this.pageIndex = data.users.page.number + 1;
        }
      });
    }
  }
  // 模糊搜索
  onMemberSearch(value: string): void {
    this.isLoading = true;
    this.pageIndex = 1;
    const param = {
      size: this.pageSize.toString(),
      page: this.pageIndex.toString(),
      searchKey: value
    };
    this.taskService.getBoardUer(this.boardData.id, param).subscribe((res: any) => {
      if (res) {
        this.memberList = res.users ? res.users.data : [];
        this.isLoading = false;
        this.pageIndex = res.users.page.number + 1;
      }
    });
  }
  taskOrderViewChange(boardId, groupId, item) {
    if (item.taskOrderEnable === 'false' || item.taskOrderEnable === false) {
      item.taskOrderEnable = true;
      this.taskOrderEnableVisible = true;
    } else {
      this.taskOrderEnableVisible = false;
      item.taskOrderEnable = false;
    }
    const param = {
      taskOrderEnable: this.taskOrderEnableVisible ? true : false
    };
    this.dataSubscription = this.taskService.doEditGroupTitle(boardId, groupId, param).subscribe((res: any) => {});
  }


  checkLabelExist(in_label: string) {
    let existFlag = false;
    if (this.groupLabels && this.groupLabels.length > 0) {
      for (const label of this.groupLabels) {
        if (in_label.trim() === label.trim()) {
          existFlag = true;
          break;
        }
      }
    }
    return existFlag;
  }

  // 下拉组件 处理新增标签
  handleDropdownInputConfirm(group: any): void {
    // 输入框无值时不处理
    if (!this.dropdownInputValue) {
      return;
    }
    // 检查标签是否存在
    if (this.checkLabelExist(this.dropdownInputValue)) {
      this.message.info('该标签已经存在，无需重复添加!');
      return;
    }
    this.groupLabels.push(this.dropdownInputValue);
    const groupId = group.id;
    const boardId = group.boardId;
    const labels = [];
    if (group.label) {
      labels.push(group.label.split(','));
    }
    labels.push(this.dropdownInputValue);
    const newLabel = labels.join(',');
    this.boardGroupData.forEach(value => {
      if (value.id === group.id) {
        value.label = newLabel;
      }
    });
    const newOption = {
      'label': newLabel
    };
    this.taskService.doEditGroupLabel(boardId, groupId, newOption).subscribe(() => { }, (err) => {
      this.message.create('error', '处理失败！');
    }, () => {
      this.dropdownInputValue = '';
    });
  }

  // 下拉组件 限制标签文字长度
  sliceTagName(tag: string): string {
    const isLongTag = tag.length > 20;
    return isLongTag ? `${tag.slice(0, 20)}...` : tag;
  }

  // 下拉组件 关闭选中标签
  handleDropdownClose(group, label): void {
    const labels = group.label.split(',');
    let newLabel = '';
    if (labels) {
      console.log(labels);
      labels.splice(labels.findIndex(v => v === label), 1);
      newLabel = labels.join(',');
      this.boardGroupData.forEach(value => {
        if (value.id === group.id) {
            value.label = newLabel;
          }
      });
    }
    const param = {
      label: newLabel
    };
    console.log(this.boardGroupData);
    this.taskService.doEditGroupLabel(group.boardId, group.id, param).subscribe((res: any) => {});
  }

  handleDropdownOption(group, val) {
    console.log(val);
    const labels = [];
    let existFlag = false;
    if (group.label) {
      const oldLabel = group.label.split(',');
      oldLabel.forEach(v => {
        if (v === val) {
          existFlag = true;
        }
        labels.push(v);
      });
    }
    if (existFlag) {
      this.message.info('该标签已经存在，无需重复添加!');
      return;
    }
    labels.push(val);
    const newLabel = labels.join(',');
    this.boardGroupData.forEach(value => {
      if (value.id === group.id) {
        value.label = newLabel;
      }
    });
    this.taskService.doEditGroupLabel(group.boardId, group.id, {label: newLabel}).subscribe((res: any) => {});
  }
  genID(length) {
    return Number(Math.random().toString().substr(3, length) + Date.now()).toString(36);
  }

}


